import {ref} from 'vue'
import _ from 'lodash'
import {PanelContentRequest} from '@tritt/multipanel'

export enum NavGroup {
    START = 'Start',
    ORGANIZATION = 'Organization',
    CREATE_ENTRY = 'CreateEntry',
    REPORTS = 'Reports',
    IMPORTS = 'Imports',
    MISC = 'Miscellaneous',
    PAYMENTS = 'Payments',
    ACCOUNTING = 'Accounting'
}


export type NavigationEntry = {
    title: string,
    key: string,
    icon: string,
    target: PanelContentRequest,
    sortOrder?: number,
}

const navigationEntries = ref<Record<NavGroup, NavigationEntry[]>>({
    [NavGroup.START]: [],
    [NavGroup.ORGANIZATION]: [],
    [NavGroup.CREATE_ENTRY]: [],
    [NavGroup.REPORTS]: [],
    [NavGroup.IMPORTS]: [],
    [NavGroup.MISC]: [],
    [NavGroup.PAYMENTS]: [],
    [NavGroup.ACCOUNTING]: []
})

export const registerNavigationEntry = (group: NavGroup, entry: NavigationEntry) => {
    if (navigationEntries.value[group].some(e => e.key === entry.key)) {
        console.warn(`Navigation entry with key "${entry.key}" already exists in group "${group}". Skipping registration.`)
        return
    }
    navigationEntries.value[group].push(entry)
}

export const getNavigationEntriesByGroup = (group: NavGroup): NavigationEntry[] => {
    const entries = navigationEntries.value[group] || []

    return _.sortBy(entries, ['sortOrder', 'title'])
}